export enum Role {
  Sys = 1,
  Admin = 2,
  SuperUser = 3,
  User = 4
}
